import React, { useContext } from 'react';
import { CardContext } from '../../../store/CardContext';

function HighlightImage({ theme }) {
  const [cardData] = useContext(CardContext);

  // Collect all available images
  const images = [
    cardData.highlightPhotos1,
    cardData.highlightPhotos2,
    cardData.highlightPhotos3,
    cardData.highlightPhotos4,
    cardData.highlightPhotos5,
    cardData.highlightPhotos6,
    cardData.highlightPhotos7,
    cardData.highlightPhotos8,
  ].filter(Boolean); // Filter out null or undefined values

  return (
    <div
      className={`p-2 rounded-[8px] ${
        images.length === 1
          ? 'w-full'
          : 'grid grid-cols-2 gap-3'
      }`}
    >
      {images.map((src, index) => (
        <img
          key={index}
          className={`rounded-[8px] ${theme ? 'rounded-xl' : ''} ${
            images.length % 2 !== 0 && index === images.length - 1
              ? 'col-span-2'
              : ''
          }`}
          src={src}
          alt={`Highlight ${index + 1}`}
          style={{ width: images.length === 1 ? '100%' : 'auto' }}
        />
      ))}
    </div>
  );
}

export default HighlightImage;
